export default __webpack_public_path__ + "static/media/wizards logo 2.e1e3c47d.jpg";